module.exports = __webpack_public_path__ + "static/media/strongher15_preview.a9e23b39.jpg";